import { v4 as uuidv4 } from 'uuid';

export function SearchNotFoundLayout(props = {}, childrenComponents = []) {
	return {
		componentName: 'SearchNotFoundLayout',
		componentId: uuidv4(),
		props,
		childrenComponents,
	};
}
